import Ionic from "ionic";
import _ from "lodash/lodash";
import ViewController from "core/views/view.controller";

export default class CalendarCtrl extends ViewController {
    static $inject = ['$scope', '$ionicScrollDelegate', '$timeout'];

    constructor() {
        super(...arguments);

        this._zoom = 1;

        // Bindings
        this.calendar = null;
        this.onItemTap = null;
        this.minZoom = 1;
        this.maxZoom = 10;

        this.onZoomFinished = _.debounce(() => {
            this.$ionicScrollDelegate.$getByHandle('splitViewLeftScroll').getScrollView().freezeShut(false);

        }, 250);

        this.zoomByFactor = _.debounce(zoomFactor => {
            Ionic.DomUtil.requestAnimationFrame(() => {
                this.zoom += zoomFactor;
                this.update();
            });

        }, 100);

        this.rowHeight = 60;
    }

    $onChanges(changes) {
        if (changes.minZoom && this.minZoom == null) {
            this.minZoom = 1;
        }

        if (changes.maxZoom && this.maxZoom == null) {
            this.maxZoom = 10;
        }

        this.update();
    }

    onZoomIn($event) {
        this.$ionicScrollDelegate.$getByHandle('splitViewLeftScroll').getScrollView().freezeShut(true);
        this.zoomByFactor(-1);
        this.onZoomFinished();
    }

    onZoomOut($event) {
        this.$ionicScrollDelegate.$getByHandle('splitViewLeftScroll').getScrollView().freezeShut(true);
        this.zoomByFactor(1);
        this.onZoomFinished();
    }

    set zoom(zoom) {
        if (zoom == null || zoom < 1) {
            zoom = 1;
        }

        if (zoom < this.minZoom) {
            zoom = this.minZoom;
        }

        if (zoom > this.maxZoom) {
            zoom = this.maxZoom;
        }

        this._zoom = zoom;
    }

    get zoom() {
        return this._zoom;
    }

    update() {
        this.rowHeight = 60 * this.zoom;
    }

}




// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/calendar.controller.js